import type { HomePlanStatus } from "api-types/homePlans/homePlanTypes";
import type {
  ClientLocationSummaryCategory,
  ClientLocationSummaryPlanBreakdownDateRange,
  ClientLotStatusBreakdownType,
} from "api-types/locations/locationsResponses";
import type { LotStatus } from "api-types/lots/lotTypes";

export const locationSummaryPhaseLabels: Record<HomePlanStatus | "TOTAL", string> = {
  PREP: "Plan Prep",
  PRE_CONSTRUCTION: "Pre-Construction",
  CONSTRUCTION: "Construction",
  TOTAL: "Total",
};

export const locationSummaryCategoryLabels: Record<ClientLocationSummaryCategory | "TOTAL", string> = {
  testing: "Testing",
  contract: "Contract",
  prospect: "Prospect",
  closed: "Inactive",
  TOTAL: "Total",
};

export const lotStatusLabels: Record<LotStatus | "TOTAL", string> = {
  available: "Available",
  unavailable: "Unavailable",
  pending: "Pending",
  sold: "Sold",
  closed: "Closed",
  TOTAL: "Total",
};

export const lotTypeLabels: Record<ClientLotStatusBreakdownType, string> = {
  none: "Standard",
  model: "Model",
  spec: "Spec",
};

export const planBreakdownRangeLabels: Record<ClientLocationSummaryPlanBreakdownDateRange, string> = {
  ALL: "All",
  "6M": "6M",
  "3M": "3M",
  "1M": "1M",
};
